<header id="header" class="fullHeight">
  <div class="container text-center fullHeight">
    <div class="row d-flex align-items-center justify-content-end" style="height: 100%;">



      <!-- inline styles for future super admin control -->
      <div class="lLeft col-md-6" style="background-image: url(../../assets/images/login/login-bg.jpg);">
        <div class="overlay" style="background-color: #ffffff; opacity: 0.4;">
        </div>
      </div>

      <div class="lRight col-md-6">
        <div class="logo">
          <img src="../../assets/images/logo/logo-blue-circle.svg" alt="Indy Chamber Logo" />
        </div>

        <div id="new-password">
          <div class="loginMessage">
            <div class="messageHeader">Create New Password</div>
            <div class="messageText">Please create a password below. If you ever need to update your password, you can do so in your account settings. Welcome back to the Indy Chamber member portal!</div>
          </div>
          <form [formGroup]="resetForm">
            <fieldset class="form-group">
              <div class="form-floating">
                <input class="form-control form-control-lg" placeholder="" type="password"
                       formControlName="password1" autocomplete="off">
                <password-strength-meter [password]="pass1" [enableFeedback]="true" (strengthChange)="strengthChanged($event)" />
                <label><i class="fa-regular fa-lock me-1"></i> New Password</label>
              </div>
            </fieldset>
            <fieldset class="form-group mt-3">
              <div class="form-floating">
                <input class="form-control form-control-lg" placeholder="" type="password"
                       formControlName="password2" autocomplete="off">
                <label><i class="fa-regular fa-lock me-1"></i> Confirm New Password</label>
              </div>
            </fieldset>
            <div *ngIf="showErrors" class="mb-4 mt-4">
              <div *ngIf="tooShort()" class="alert alert-danger">
                Password must be at least 8 characters.
              </div>
              <div *ngIf="passwordMismatch()" class="alert alert-danger">
                Passwords must match.
              </div>
              <div *ngIf="lowStrength()" class="alert alert-danger">
                Password must be at least strength 3
              </div>
            </div>
            <fieldset class="mt-4">
              <button type="button" (click)="initiateReset()" class="btn btn-lg btn-block login-btn w-100">Save New Password</button>
            </fieldset>
          </form>
          <div class="login-links mt-3">
            <a class="text-link-blue" id="login-back-link" href="#">
              <i class="far fa-arrow-left"></i> back to
              login
            </a>
          </div>
        </div>



      </div>

    </div>



  </div>
</header>


<!-- Footer-->
<footer hidden class=" py-2 bg-light">
  <div class="container px-4"><p class="m-0 text-center text-dark">Copyright &copy; Indy Chamber 2024</p></div>
</footer>
